import React, { Component } from "react";
import { Grid, Icon, Image, Menu } from "semantic-ui-react";
import { UserContext } from "context/userProvider";
import "scss/components/Sidebar.scss";

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      activeItem: "dashboard",
      activeIndex: 0,
      isCategories: false,
      isReports: false,
      isSetting: false,
      categoriesName: "",
    };
  }

  componentDidMount() {
    this.handleSetActive();
  }

  handleSetActive = () => {
    const { tabActive, categories, reports, setting } = this.props;
    this.setState({
      activeItem: tabActive,
      isCategories: categories,
      isReports: reports,
      isSetting: setting,
    });
  };

  handleItemClick = (e, { name }) => {
    const { activeItem } = this.state;
    if (name === "iotDevice") {
      if (activeItem === "iotDevice") {
        this.setState({
          activeItem: "iotDevice",
          isCategories: !this.state.isCategories,
        });} 
      else { 
      this.setState({ activeItem: "iotDevice", isCategories: name });
    }

    } else if (name === "deviceData") {
      if (activeItem === "deviceData") {
        this.setState({
          activeItem: "deviceData",
          isReports: !this.state.isReports,
        });} 
      else {
      this.setState({ activeItem: "deviceData", isReports: name });
    }

    } else if (name === "setting") {
      if (activeItem === "setting") {
        this.setState({
          activeItem: "setting",
          isSetting: !this.state.isSetting,
        });} 
      else {
      this.setState({ activeItem: "setting", isSetting: name });
    }

    } else {
      this.setState({
        activeItem: name,
        isCategories: "",
        isReports: "",
        isSetting: "",
      });
    }
  };

  menuForServiceTeam = () => {
    const { activeItem } = this.state;
    return (
      <>
        <Menu.Item
          name="pending"
          active={activeItem === "pending"}
          onClick={this.handleItemClick}
          href="/pending-list"
        >
          <div>
            <Icon name="tasks" />
            &ensp;รอดำเนินการซ่อม
          </div>
        </Menu.Item>
      </>
    );
  };

  menuForService = () => {
    const { activeItem, isCategories, isReports, isSetting } = this.state;
    return (
      <>
        <Menu.Item
          name="devicesStatus"
          active={activeItem === "devicesStatus"}
          onClick={this.handleItemClick}
          href="/device-status"
        >
          <div>
            <Icon name="cubes" />
            &ensp;ติดตามสถานะอะไหล่
          </div>
        </Menu.Item>

        <Menu.Item
          name="maintenanceInform"
          active={activeItem === "maintenanceInform"}
          onClick={this.handleItemClick}
          href="/maintenance-list"
        >
          <div>
            <Icon name="clipboard" />
            &ensp;แจ้งซ่อม
          </div>
        </Menu.Item>

        <Menu.Item
          name="saReceived"
          active={activeItem === "saReceived"}
          onClick={this.handleItemClick}
          href="/sa-receive-list"
        >
          <div>
            <Icon name="edit" />
            &ensp;Service Admin รับเรื่อง
          </div>
        </Menu.Item>
        <Menu.Item
          name="pending"
          active={activeItem === "pending"}
          onClick={this.handleItemClick}
          href="/pending-list"
        >
          <div>
            <Icon name="tasks" />
            &ensp;รอดำเนินการซ่อม
          </div>
        </Menu.Item>

        <Menu.Item
          name="maintenanceRecord"
          active={activeItem === "maintenanceRecord"}
          onClick={this.handleItemClick}
          href="/record-list"
        >
          <div>
            <Icon name="address card" />
            &ensp;ประวัติการซ่อม
          </div>
        </Menu.Item>

        <Menu.Item
          name="customersRecord"
          active={activeItem === "customersRecord"}
          onClick={this.handleItemClick}
          href="/customers-list"
        >
          <div>
            <Icon name="users" />
            &ensp;ประวัติลูกค้า
          </div>
        </Menu.Item>

        {/*  Device Data  */}
        <Menu.Item
          name="deviceData"
          index={0}
          active={activeItem === "deviceData"}
          onClick={this.handleItemClick}
        >
          <div>
            <Icon name="chart bar" />
            &ensp;ข้อมูลเครื่องจักร
          </div>
          {isReports !== false && activeItem === "deviceData" ? (
            <Icon name="angle up" />
          ) : (
            <Icon name="angle down" />
          )}
        </Menu.Item>

        {activeItem === "deviceData" && isReports !== false && (
          <>
            <Menu.Item
              name="pairDevice"
              active={isReports === "pairDevice"}
              onClick={this.handleItemClick}
              href="/pair-device-list"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;การผูกข้อมูล
              </div>
            </Menu.Item>

            <Menu.Item
              name="machineList"
              active={isReports === "machineList"}
              onClick={this.handleItemClick}
              href="/machine-list"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;Machine Profile
              </div>
            </Menu.Item>
          </>
        )}

        {/* IoT Device */}
        <Menu.Item
          name="iotDevice"
          index={0}
          active={activeItem === "iotDevice"}
          onClick={this.handleItemClick}
        >
          <div>
            <Icon name="tags" />
            &ensp;ข้อมูลอุปกรณ์ IoT
          </div>
          {isCategories !== false && activeItem === "iotDevice" ? (
            <Icon name="angle up" />
          ) : (
            <Icon name="angle down" />
          )}
        </Menu.Item>

        {activeItem === "iotDevice" && isCategories !== false && (
          <>
            <Menu.Item
              name="iotNumber"
              active={isCategories === "iotNumber"}
              onClick={this.handleItemClick}
              href="/iot-number"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;หมายเลขอุปกรณ์ IoT
              </div>
            </Menu.Item>
            <Menu.Item
              name="deviceNumber"
              active={isCategories === "deviceNumber"}
              onClick={this.handleItemClick}
              href="/device-number"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;หมายเลขเครื่องจักร
              </div>
            </Menu.Item>
            <Menu.Item
              name="deviceModel"
              active={isCategories === "deviceModel"}
              onClick={this.handleItemClick}
              href="/device-model"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;รุ่นเครื่องจักร
              </div>
            </Menu.Item>
            <Menu.Item
              name="deviceParts"
              active={isCategories === "deviceParts"}
              onClick={this.handleItemClick}
              href="/device-parts"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;อะไหล่เครื่องจักร
              </div>
            </Menu.Item>
          </>
        )}

        {/*  Setting  */}
        {this.context.userDetail?.role === "admin" && (
          <>
            <Menu.Item
              name="setting"
              index={0}
              active={activeItem === "setting"}
              onClick={this.handleItemClick}
            >
              <div>
                <Icon name="setting" />
                &ensp;การตั้งค่า
              </div>
              {isSetting !== false && activeItem === "setting" ? (
                <Icon name="angle up" />
              ) : (
                <Icon name="angle down" />
              )}
            </Menu.Item>
          </>
        )}
        {activeItem === "setting" && isSetting !== false && (
          <>
            <Menu.Item
              name="company"
              active={isSetting === "company"}
              onClick={this.handleItemClick}
              href="/setting/company"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;กิจการ
              </div>
            </Menu.Item>

            <Menu.Item
              name="users"
              active={isSetting === "users"}
              onClick={this.handleItemClick}
              href="/setting/users"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;ผู้ใช้งาน
              </div>
            </Menu.Item>

            {/* <Menu.Item
              name="users"
              active={isSetting === "company"}
              onClick={this.handleItemClick}
              href="/setting"
            >
              <div>
                &emsp;
                <Icon name="angle double right" />
                &ensp;กำหนดสิทธิผู้ใช้งาน
              </div>
            </Menu.Item>          */}
          </>         
        )}
          <div > v.20241009  </div>
      </>
    );
  };

  render() {
    const { activeItem } = this.state;
    return (
      <div className="sideBar">
        {/* {this.context.userDetail != null ? ( */}
        <Grid.Column width={4}>
          <Menu fluid pointing secondary vertical>
            <Menu.Item>
              <Image src={process.env.PUBLIC_URL + "/images/CLP_LOGO.png"} />
            </Menu.Item>
            <Menu.Item
              name="dashboard"
              active={activeItem === "dashboard"}
              onClick={this.handleItemClick}
              href="/home"
            >
              <div>
                <Icon name="dashboard" />
                &ensp;หน้าแรก
              </div>
            </Menu.Item>
            {this.context.userDetail?.role === "sst"
              ? this.menuForServiceTeam()
              : this.menuForService()}
          </Menu>
        </Grid.Column>
        {/* ) : (
          <Navigate to="/" />
        )} */}
      </div>
    );
  }
}

Sidebar.contextType = UserContext;
